var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
var cls = classNames('onboarding-button');
export var OnboardingButtonDefaultProps = {
  onClick: function () {},
  colors: {
    background: 'primary',
    text: 'light',
    hover: {
      background: 'primary',
      text: 'light'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", " \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: ", " ", ";\n    border-radius: ", ";\n    border: none;\n    font-family: ", ";\n    font-size: 1em;\n    font-weight: 500;\n    cursor: pointer;\n\n  "], ["\n    ", " \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: ", " ", ";\n    border-radius: ", ";\n    border: none;\n    font-family: ", ";\n    font-size: 1em;\n    font-weight: 500;\n    cursor: pointer;\n\n  "])), theme.APPLY_COLORS, theme.UNIT(3), theme.UNIT(6), theme.UNIT(8), theme.FONT('sans'))
});
// -------- Components -------->
var My = {
  NAME: 'OnboardingButton',
  Container: styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var OnboardingButton = function (props) {
  var _a = useComponentProps(My.NAME, OnboardingButtonDefaultProps, props),
    className = _a.className,
    children = _a.children,
    onClick = _a.onClick,
    colors = _a.colors;
  return React.createElement(My.Container, {
    onClick: onClick,
    colors: colors,
    className: cls.name(className)
  }, children);
};
OnboardingButton.cls = cls;
var templateObject_1, templateObject_2;